import { useRef, useState } from "react";
import { TipoDocumento } from "../../types/tipoDocumento/TipoDocumento";

import { Autocomplete, CircularProgress, TextField } from "@mui/material";
import useTipoDocumentoFetch from "./useTipoDocumentoFetch";


type Props = {
    isdisabled?: boolean;
    isLoading?: boolean;
    required?: boolean;
    value?: TipoDocumento;
    handleSearchChange: (newValue: TipoDocumento) => void;
};


const TxtTipoDocumento = ({
    isdisabled,
    isLoading,

    required = false,
    value,
    handleSearchChange,

}: Props) => {


    const timeoutRef = useRef<number | null>(null);
    const loading = useRef(false);




    const handleSetLoad = (newValue: boolean) => {
        loading.current = newValue;
    };

    const [inputValue, setInputValue] = useState("");
    const { options } = useTipoDocumentoFetch({ inputValue, handleSetLoad });


    return (
        <Autocomplete

            value={value && value.id ? value : null}
            size="small"
            options={options}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            getOptionLabel={(option) => {
                const tipoDocumento = option as TipoDocumento;
                return tipoDocumento.nome ? tipoDocumento.nome : "";
            }}
            loading={loading.current}

            onInputChange={(event, newInputValue) => {

                if (timeoutRef.current) {
                    clearTimeout(timeoutRef.current);
                }
                timeoutRef.current = window.setTimeout(() => {
                    setInputValue(newInputValue);


                }, 700); // 300ms delay
            }}

            onChange={(event, newValue) => {
                handleSearchChange(newValue as TipoDocumento);
            }}

            onBlur={() => {
                // Verifica se o valor digitado corresponde a uma das opções
                if (!value || !options.some(option => option.nome === value.nome)) {
                    setInputValue(""); // Limpa o campo se não for uma opção válida                    
                }
            }}

            renderInput={(params) => (
                <TextField
                    {...params}
                    label="Tipo Documento"
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {loading.current ? (
                                    <CircularProgress color="inherit" size={20} />
                                ) : null}
                                {params.InputProps.endAdornment}
                            </>
                        ),
                    }}
                />
            )}

        />
    );








}
export default TxtTipoDocumento;

